const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data.message || data.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }
  return data;
};

/**
 * List all databases on the server whose name starts with "training",
 * excluding the live "training-db".
 * @returns {Promise<string[]>}
 */
export const listTrainingDatabases = async () => {
  return await makeRequest(`${API_BASE_URL}/api/training-revert/databases`);
};

/**
 * Start the revert operation asynchronously.
 * @param {string} selectedDatabase - The backup DB name to restore from.
 * @param {string} branch - The Blackbird_Database branch to build & deploy.
 * @returns {Promise<{ operationId: string }>}
 */
export const executeRevert = async (selectedDatabase, branch) => {
  return await makeRequest(`${API_BASE_URL}/api/training-revert/execute`, {
    method: 'POST',
    body: JSON.stringify({ selectedDatabase, branch }),
  });
};

/**
 * List branches available in the Blackbird_Database repo.
 * @returns {Promise<string[]>}
 */
export const getDatabaseBranches = async () => {
  return await makeRequest(`${API_BASE_URL}/api/training-revert/branches`);
};

/**
 * Poll the status of a running revert operation.
 * @param {string} operationId
 * @returns {Promise<TrainingRevertSession>}
 */
export const getRevertStatus = async (operationId) => {
  return await makeRequest(
    `${API_BASE_URL}/api/training-revert/status/${encodeURIComponent(operationId)}`
  );
};

/**
 * Retry a failed revert operation from the last succeeded step.
 * @param {string} operationId
 * @returns {Promise<{ operationId: string }>}
 */
export const retryRevert = async (operationId) => {
  return await makeRequest(
    `${API_BASE_URL}/api/training-revert/retry/${encodeURIComponent(operationId)}`,
    { method: 'POST' }
  );
};

/**
 * Get the history of recent revert operations.
 * @param {number} count
 * @returns {Promise<TrainingRevertSession[]>}
 */
export const getRevertHistory = async (count = 20) => {
  return await makeRequest(
    `${API_BASE_URL}/api/training-revert/history?count=${count}`
  );
};
